<template>
  <div v-if="jsonData!==null&&typeof jsonData.list!=='undefined'">
    <a-form
      class="k-build-form"
      :layout="jsonData.config.layout"
      :hideRequiredMark="jsonData.config.hideRequiredMark"
      :form="form"
      @submit="handleSubmit"
      :style="{
        width: jsonData.config.width,
        marginTop: jsonData.config.marginTop,
        marginRight: jsonData.config.marginRight,
        marginBottom: jsonData.config.marginBottom,
        marginLeft: jsonData.config.marginLeft
      }"
    >
      <buildBlocks
        v-if="advanced"
        @handleReset="handleReset"
        v-for="(record, index) in jsonData.list"
        :record="record"
        :config="jsonData.config"
        :key="index"
      />

      <a-form-item>
        <a-col :md="24" :sm="24" style="margin-top: 20px">
          <span class="table-page-search-submitButtons">
            <!--            <a-button v-if="advanced" type="primary" @click="handleSubmit">{{ $t('button.query') }}</a-button>-->
            <!--            <a-button v-if="advanced" type="primary"  style="margin-left: 8px" @click="handleReset">{{ $t('button.reset') }}</a-button>-->
            <a @click="toggleAdvanced" style="margin-left: 6px">
              {{ advanced ? $t('button.fold') : $t('button.unfold') }}
              <a-icon :type="advanced ? 'up' : 'down'" />
            </a>
          </span>
        </a-col>
      </a-form-item>

      <vxe-grid
        border
        stripe
        resizable
        highlight-hover-column
        highlight-current-column
        highlight-hover-row
        highlight-current-row
        show-overflowd
        export-config
        height="750"
        :loading="loading"
        :toolbar="tableToolbar"
        :data="tableData"
        :sort-config="{trigger: 'cell'}"
        :edit-config="{trigger: 'click', mode: 'row', showStatus: true}"
        @sort-change="sortChangeEvent"
        @toolbar-button-click="toolbarButtonClickEvent">
        <!--eslint-disable-next-line-->
        <div v-for="item in tableColumn">
          <vxe-table-column
            :type="item.type"
            :field="item.field"
            :title="item.title"
            :visible="item.visible"
            :width="item.width"
            :fixed="item.fixed"
            :showOverflow="item.showOverflow"
            :formatter="item.formatter"
            :sortable="item.sortable"
            :filters="[{data: {vals: [], sVal: '', fMenu: '', f1Type:'', f1Val: '', fMode: 'and', f2Type: '', f2Val: ''}}]"
            :filter-render="{name: 'FilterExcel'}">
          </vxe-table-column>
        </div>
      </vxe-grid>
      <a-pagination
        @showSizeChange="handleSizeChange"
        @change="handleCurrentChange"
        v-model="tablePage.currentPage"
        :page-size-options="['5', '10', '15', '20', '50', '100', '150', '200','1000','2000','5000','10000','100000']"
        :page-size="tablePage.pageSize"
        :total="tablePage.totalResult"
        showSizeChanger
        showQuickJumper>
      </a-pagination>
    </a-form>
  </div>
</template>
<script>
  import { findOne, post } from '@/api/Api'
  import Vue from 'vue'
  import buildBlocks from '../../components/KBuildForm/buildBlocks'
  import moment from 'moment'
  import { getTableDataByApi } from '@/api/admin'
  import { WAREHOUSE, OPERATOR } from '@/store/mutation-types'
  import api from '@/api'

  export default {
    name: 'Query',
    components: {
      buildBlocks
    },
    //inject:['beginSign'],
    data() {
      return {
        advanced: false,
        form: this.$form.createForm(this),
        tableData: [],
        loading: false,
        tablePage: {
          currentPage: 1,
          pageSize: 10,
          totalResult: 0
        },
        tableToolbar: {
          buttons: [
            { code: 'query', name: 'button.query' },
            { code: 'reset', name: 'button.reset' }
          ],
          zoom: true,
          custom: true,
          export: true,
          resizable: {
            storage: true
          }
        },
        validRules: null,
        tableColumn: [],
        jsonData: {},
        queryItem: null
      }
    },
    mounted() {
      const that = this
      findOne('queryFactory', { id: this.queryParam.value.queryParam.id }).then((body) => {
        that.queryItem = body
        that.jsonData = JSON.parse(that.queryItem.queryTerms)
        that.tableColumn = JSON.parse(that.queryItem.columns)
        that.findList()
      })
    },
    watch: {
      '$route'(to, from) {
        const that = this
        findOne('queryFactory', { id: this.queryParam.value.queryParam.id }).then((body) => {
          that.queryItem = body
          that.jsonData = JSON.parse(that.queryItem.queryTerms)
          that.tableColumn = JSON.parse(that.queryItem.columns)
          that.findList()
        })
      }
    },
    props: {
      'queryParam': {
        type: Object,
        default: null
      }
    },
    methods: {
      moment,
      handleSubmit(e) {
        // 提交按钮触发，并触发submit函数，返回getData函数
        // e.preventDefault();
        //alert(this.form.values)
        //this.$emit('submit', this.getData);
        //const aa = this.form.getFieldsValue()
        this.findList()
      },
      handleReset() {
        this.form.resetFields()
      },
      toolbarButtonClickEvent({ code }, event) {
        switch (code) {
          case 'query':
            this.$sign({
              reason: '测试',
              button: 'query',
              router: this.$route,
              click: () => {
                // 点击按钮事件
                console.log(this.reason, 'reason')
                this.findList()
              }
            })
            break
          case 'reset':
            this.handleReset()
        }
      },
      handleCurrentChange({ currentPage, pageSize }) {
        this.tablePage.currentPage = currentPage
        this.findList()
      },
      handleSizeChange(current, size) {
        this.tablePage.pageSize = size
        this.findList()
      },
      findList() {
        this.loading = true
        const params = this.form.getFieldsValue()
        const paramModel = JSON.parse(this.jsonData.paramModel)
        Object.keys(paramModel).forEach(k => {
          // paramModel.set(k,params.get(k)?params.get(k):'')
          paramModel[k] = params[k] === undefined ? '' : params[k]
        })
        console.log(paramModel, 'paramModel')
        const parameter = {
          warehouse: Vue.ls.get(WAREHOUSE),
          qry: true,
          executor: Vue.ls.get(OPERATOR),
          'query.no': this.queryItem.no,
          args: paramModel
        }
        let promise = null
        if (this.jsonData.queryType === '1') {
          promise = getTableDataByApi(this.jsonData.apiDesc.method,
            this.jsonData.apiDesc.url,
            JSON.parse(this.jsonData.apiDesc.headers),
            paramModel
          )
        } else {
          promise = post(api.adminQuery, {}, parameter)
        }

        promise.then((body) => {
          const result = body
          this.tablePage.totalResult = result.length
          this.tableData = result.slice((this.tablePage.currentPage - 1) * this.tablePage.pageSize, this.tablePage.currentPage * this.tablePage.pageSize)
          this.loading = false
        }).catch(e => {
          this.loading = false
        })
      },
      toggleAdvanced() {
        this.advanced = !this.advanced
      },
      sortChangeEvent({ column, property, order }) {
        console.info(property, order)
      }
    }
  }
</script>
<style lang="less">
  @import "../../styles/kkTable.less";
</style>
